import useColorService from '@/services/ColorService';
import BaseEntity from './BaseEntity';

export default class OrganizationRoleListItemEntity extends BaseEntity<IOrganizationRoleListItemModel> {

	get name () { return this.state.name }
	get colorName () { return useColorService().swapColor(this.state.colorName) }

}
